import { render } from "./FactorySection.vue?vue&type=template&id=7db4b592&scoped=true&bindings={}"
import script from "./FactorySection.vue?vue&type=script&lang=ts"
export * from "./FactorySection.vue?vue&type=script&lang=ts"

import "./FactorySection.vue?vue&type=style&index=0&id=7db4b592&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7db4b592"

export default script